"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupedOptions = exports.getCategoryById = void 0;
const feed_factory_data_categorization_ontology_1 = require("@feed-factory/feed-factory.data.categorization-ontology");
const _ = __importStar(require("lodash"));
// The categorizationSourceDictionary contains ALL items, including deprecated items
// and of any entityType value. Filtering occurs in other functions.
// PRIVATE, should not be accessed by external logic
let categorizationSourceDictionary = null;
const getCategorizationSourceDictionary = () => {
    if (categorizationSourceDictionary)
        return categorizationSourceDictionary;
    const children = _.chain(feed_factory_data_categorization_ontology_1.categorizationOntology.categorizations)
        .map("child")
        .flatten()
        .value();
    const parents = _.cloneDeep(feed_factory_data_categorization_ontology_1.categorizationOntology.categorizations);
    parents.forEach((parent) => {
        delete parent.child;
    });
    const flattenedCategorizationSource = children
        .concat(parents)
        .filter((item) => item === null || item === void 0 ? void 0 : item.categorization);
    let catDictionary = {};
    flattenedCategorizationSource.forEach((cat) => {
        const catClone = Object.assign({}, cat);
        const id = catClone.cnetID;
        delete catClone.cnetID;
        catDictionary[id] = catClone;
    });
    return catDictionary;
};
// Looks at all possible item types, including deprecated and all entityTypes
const getCategoryById = (id) => {
    var _a, _b;
    // Determine if valid id
    if (((_a = id.match(/[0-9]+.[0-9]+(.[0-9]+)?/)) === null || _a === void 0 ? void 0 : _a[0]) !== id) {
        console.error(`Requested category with invalid ID: ${id}`);
        return null;
    }
    return (_b = getCategorizationSourceDictionary()[id]) === null || _b === void 0 ? void 0 : _b.categorization;
};
exports.getCategoryById = getCategoryById;
// Filters on deprecated and entityType status
const getGroupedOptions = (entityType = undefined, showDeprecated = false) => {
    const groupedOptions = feed_factory_data_categorization_ontology_1.categorizationOntology.categorizations
        .filter((cat) => showDeprecated || !cat.deprecated)
        .filter((cat) => !cat.entityType || cat.entityType === entityType)
        .filter((topLevelCat) => !!topLevelCat.child)
        .map((topLevelCat) => {
        const transformedOptions = topLevelCat.child
            .filter((cat) => showDeprecated || !cat.deprecated)
            .map((cat) => {
            return {
                value: cat.cnetID,
                label: cat.categorization,
            };
        })
            .sort((a, b) => (a.label < b.label ? -1 : 1));
        return {
            label: topLevelCat.categorization,
            options: transformedOptions,
        };
    })
        .sort((a, b) => (a.label < b.label ? -1 : 1));
    return groupedOptions;
};
exports.getGroupedOptions = getGroupedOptions;
//# sourceMappingURL=categorizationHelper.js.map